/* Simply Active — product card interactions (swatches + quick add: colour then size) */
(function () {
  if (window.__saCardInit) return;
  window.__saCardInit = true;

  var css = [
    '.sa-card .sa-card__plate{position:relative}',
    '.sa-card .sa-card__quick{position:absolute;left:10px;right:10px;bottom:10px;top:auto;opacity:0;visibility:hidden;transform:translateY(10px);transition:opacity .22s ease,transform .22s ease,visibility .22s;z-index:4;pointer-events:none;background:none;padding:0;display:block}',
    '@media (hover:hover) and (min-width:1024px){.sa-card:hover .sa-card__quick,.sa-card:focus-within .sa-card__quick{opacity:1;visibility:visible;transform:none;pointer-events:auto}}',
    '.sa-card.is-quickopen .sa-card__quick{opacity:1;visibility:visible;transform:none;pointer-events:auto}',
    '.sa-qa{background:rgba(255,255,255,.97);padding:14px 10px 10px;box-shadow:0 8px 28px rgba(21,21,15,.10)}',
    '.sa-qa__title{font-family:Archivo,Helvetica,Arial,sans-serif;font-size:12px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;text-align:center;color:#15150f;margin:0 0 10px}',
    '.sa-qa__title span{font-weight:400;color:#77776c}',
    '.sa-qa__step{font-family:Archivo,Helvetica,Arial,sans-serif;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#8a877e;margin:0 0 6px}',
    '.sa-qa__colours{display:flex;flex-wrap:wrap;gap:9px;margin:0 0 12px;padding:2px}',
    '.sa-qa__colour{width:24px;height:24px;border-radius:50%;border:0;padding:0;background:var(--swatch);box-shadow:inset 0 0 0 1px rgba(0,0,0,.14);cursor:pointer;transition:transform .15s}',
    '.sa-qa__colour:hover{transform:scale(1.1)}',
    '.sa-qa__colour.is-active{box-shadow:inset 0 0 0 1px rgba(0,0,0,.14),0 0 0 2px #fff,0 0 0 3px #15150f}',
    '.sa-qa__colour:disabled{opacity:.35;cursor:not-allowed}',
    '.sa-qa__sizes{display:grid;grid-template-columns:repeat(auto-fit,minmax(36px,1fr));gap:6px}',
    '.sa-qa__size{height:40px;padding:0 4px;border:1px solid #e3dfd6;background:#fff;color:#15150f;font-family:Archivo,Helvetica,Arial,sans-serif;font-size:12px;cursor:pointer;transition:border-color .15s,background .15s,color .15s}',
    '.sa-qa__size:hover:not(:disabled){border-color:#15150f}',
    '.sa-qa__size:disabled{color:#bdb9b0;background:#f6f5f1;text-decoration:line-through;cursor:not-allowed}',
    '.sa-qa__size.is-loading{opacity:.55;pointer-events:none}',
    '.sa-qa__size.is-added{background:#15150f;border-color:#15150f;color:#f4f2ed}',
    '.sa-qa__size--wide{grid-column:1/-1;text-transform:uppercase;letter-spacing:.1em}',
    '.sa-card__colourname{display:block;font-size:12px;color:#8a877e;margin-top:2px;line-height:1.3}',
    '@media (max-width:1023px){.sa-card .sa-card__quick{left:6px;right:6px;bottom:6px}.sa-qa{padding:10px 6px 6px}.sa-qa__size{height:36px;font-size:11px}.sa-qa__colour{width:22px;height:22px}}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function toast(message) {
    var el = document.querySelector('.sa-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sa-toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.classList.remove('is-visible'); }, 1900);
  }
  window.saToast = toast;

  function readVariants(card) {
    if (card.__variants) return card.__variants;
    var tag = card.querySelector('[data-sa-variants]');
    try { card.__variants = tag ? JSON.parse(tag.textContent) : []; } catch (e) { card.__variants = []; }
    return card.__variants;
  }

  function indices(card) {
    var el = card.querySelector('[data-sa-optidx]');
    var c = el ? el.getAttribute('data-colour') : '';
    var s = el ? el.getAttribute('data-size') : '';
    return {
      colour: c === '' || c === null ? null : parseInt(c, 10),
      size: s === '' || s === null ? null : parseInt(s, 10)
    };
  }

  function findVariant(card, size, colourOverride) {
    var idx = indices(card);
    var colour = colourOverride || card.getAttribute('data-colour');
    var list = readVariants(card).filter(function (v) {
      if (idx.colour !== null && colour && v.options[idx.colour] !== colour) return false;
      if (idx.size !== null && size && v.options[idx.size] !== size) return false;
      return true;
    });
    return list.filter(function (v) { return v.available; })[0] || list[0] || null;
  }

  function refresh(card) {
    card.querySelectorAll('[data-sa-qsize]').forEach(function (btn) {
      var v = findVariant(card, btn.getAttribute('data-sa-qsize'));
      btn.disabled = !v || !v.available;
    });
    var colour = card.getAttribute('data-colour');
    card.querySelectorAll('[data-sa-qcolour]').forEach(function (b) {
      var name = b.getAttribute('data-sa-qcolour');
      b.classList.toggle('is-active', name === colour);
      var v = findVariant(card, null, name);
      b.disabled = !v || !v.available;
    });
    var qn = card.querySelector('[data-sa-qname]');
    if (qn) qn.textContent = colour ? ' · ' + colour : '';
  }

  function setColour(card, name) {
    card.setAttribute('data-colour', name);
    card.querySelectorAll('[data-sa-swatch]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-sa-swatch') === name); });
    var cn = card.querySelector('[data-sa-colourname]');
    if (cn) cn.textContent = name;
    var v = findVariant(card, null);
    var img = card.querySelector('[data-sa-primary]');
    if (v && v.image && img) { img.removeAttribute('srcset'); img.src = v.image; }
    if (name !== card.getAttribute('data-default-colour')) {
      var hov = card.querySelector('.sa-card__img--hover');
      if (hov) hov.parentNode.removeChild(hov);
    }
    var link = card.querySelector('.sa-card__imglink');
    if (link && v) link.href = link.href.split('?')[0] + '?variant=' + v.id;
    refresh(card);
  }

  function build(card) {
    var qa = card.querySelector('.sa-qa');
    var swatches = card.querySelectorAll('[data-sa-swatch]');
    if (!qa || qa.__built) return;
    qa.__built = true;
    var title = qa.querySelector('.sa-qa__title');
    if (title && !title.querySelector('[data-sa-qname]')) {
      var span = document.createElement('span');
      span.setAttribute('data-sa-qname', '');
      title.appendChild(span);
    }
    if (swatches.length > 1) {
      var step1 = document.createElement('div');
      step1.className = 'sa-qa__step';
      step1.textContent = 'Colour';
      var row = document.createElement('div');
      row.className = 'sa-qa__colours';
      swatches.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sa-qa__colour';
        b.setAttribute('data-sa-qcolour', s.getAttribute('data-sa-swatch'));
        b.setAttribute('title', s.getAttribute('data-sa-swatch'));
        b.setAttribute('aria-label', 'Colour ' + s.getAttribute('data-sa-swatch'));
        b.style.setProperty('--swatch', s.style.getPropertyValue('--swatch'));
        row.appendChild(b);
      });
      var sizes = qa.querySelector('.sa-qa__sizes');
      qa.insertBefore(step1, sizes);
      qa.insertBefore(row, sizes);
      if (sizes.querySelector('[data-sa-qsize]:not([data-sa-qsize=""])')) {
        var step2 = document.createElement('div');
        step2.className = 'sa-qa__step';
        step2.textContent = 'Size';
        qa.insertBefore(step2, sizes);
      }
    }
  }

  function updateBag() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-sa-bagcount]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }

  function quickAdd(card, btn) {
    var size = btn.getAttribute('data-sa-qsize');
    var v = findVariant(card, size);
    if (!v) { toast('Unavailable'); return; }
    if (!v.available) { toast('Sold out'); return; }
    var label = btn.textContent;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) { toast(res.d && res.d.description ? res.d.description : 'Could not add'); return; }
        btn.classList.add('is-added');
        btn.textContent = '✓';
        var colour = card.getAttribute('data-colour');
        toast('Added to bag' + (size || colour ? ' — ' + [colour, size].filter(Boolean).join(' / ') : ''));
        document.dispatchEvent(new CustomEvent('sa:cart:added', { detail: { variantId: v.id } }));
        updateBag();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = label;
          card.classList.remove('is-quickopen');
          var f = card.querySelector('.sa-card__fab');
          if (f) f.textContent = '+';
        }, 1400);
      })
      .catch(function () { btn.classList.remove('is-loading'); toast('Could not add'); });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-sa-card]').forEach(function (card) {
      if (card.__saReady) return;
      card.__saReady = true;
      build(card);
      refresh(card);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sa-swatch],[data-sa-qcolour]');
    if (sw) {
      e.preventDefault();
      if (!sw.disabled) setColour(sw.closest('[data-sa-card]'), sw.getAttribute('data-sa-swatch') || sw.getAttribute('data-sa-qcolour'));
      return;
    }

    var qs = e.target.closest('[data-sa-qsize]');
    if (qs) {
      e.preventDefault();
      e.stopPropagation();
      if (!qs.disabled) quickAdd(qs.closest('[data-sa-card]'), qs);
      return;
    }

    var fab = e.target.closest('.sa-card__fab');
    if (fab) {
      e.preventDefault();
      var c = fab.closest('[data-sa-card]');
      var open = !c.classList.contains('is-quickopen');
      document.querySelectorAll('[data-sa-card].is-quickopen').forEach(function (x) {
        if (x === c) return;
        x.classList.remove('is-quickopen');
        var f2 = x.querySelector('.sa-card__fab');
        if (f2) f2.textContent = '+';
      });
      c.classList.toggle('is-quickopen', open);
      fab.textContent = open ? '×' : '+';
      return;
    }

    if (!e.target.closest('[data-sa-card]')) {
      document.querySelectorAll('[data-sa-card].is-quickopen').forEach(function (x) {
        x.classList.remove('is-quickopen');
        var f = x.querySelector('.sa-card__fab');
        if (f) f.textContent = '+';
      });
    }
  });
})();
